import React from "react";
import createReactClass from "create-react-class";

export const field = function (properties) {
  const { tools, reload, config, types } = properties;

  const Field = createReactClass({
    componentWillMount() {
      this.fieldRef = React.createRef();
    },
    render() {
      return wrapInBlur(
        makeCorrectElement.bind(this)(),
        this.onFocus,
        this.onBlur,
        this.props.field.config,
        this.fieldRef
      );


      function makeCorrectElement() {
        var field = this.props.field;
        var fieldConfig = field.config;
        var showErrors = this.showErrors();

        var props = tools.merge(this.props, {
          onUpdate: this.onUpdate,
          errorClass: getErrorClass(
            field.state.errors,
            showErrors,
            field.state.api.running,
            field.state.errorDisabled
          ),
          errors: makeErrors(field.state.errors, showErrors),
          spinnerClass: getSpinnerClass(
            showErrors,
            field.state.api.running,
            field.config.id
          ),
        });

        var type = types(fieldConfig.type);
        if (type) {
          return React.createElement(type.html, props);
        } else return null;
      }

      function wrapInBlur(element, onFocus, onBlur, config, ref) {
        if (config.invisible) {
          return <div style={{ display: "none" }}>{element}</div>;
        } else if (config.customBlur) {
          return (
            <div ref={ref} onFocus={onFocus} className="lz-padding-top">
              {element}
            </div>
          );
        } else
          return (
            <div
              ref={ref}
              onFocus={onFocus}
              onBlur={(e) => {
                onBlur(e);
              }}
              className="lz-padding-top"
            >
              {element}
            </div>
          );
      }
    },
    componentDidMount() {
      if (this.props.grabFocus) {
        this.grabFocus();
      }
    },
    componentDidUpdate() {
      // if (this.props.grabFocus) {
      //     this.grabFocus();
      // }
    },
    grabFocus() {
      var thisComponent = this.fieldRef.current;
      if (!thisComponent) return;

      var isInViewport = isElementInViewport(thisComponent);
      if (!isInViewport) {
        thisComponent.scrollIntoView();
      }

      var input = thisComponent?.querySelector?.("input") ?? null;
      if (input) input.focus();
    },
    showErrors() {
      var props = this.props;
      var field = props.field;
      var pageConfig = this.props.parsePage(field.config.page);
      return (
        (props.showErrors && field.state.status === "blurred") ||
        props.showErrorsOnPage === pageConfig ||
        (props.showErrorsOnPage !== -1 && pageConfig === undefined)
      );
    },
    onFocus() {
      var state = this.props.field.state;
      if (state.status === "never-focused") {
        state.status = "never-blurred";
      }
      this.onUpdate();
    },
    onBlur(e) {
      var state = this.props.field.state;
      if (state.status === "never-blurred") {
        state.status = "blurred";
      }
      this.onUpdate();
    },
    onUpdate() {
      reload();
    },
  });

  function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  function getSpinnerClass(showErrors = false, apiRunning = false, id) {
    var classs = "lz-spinner" + (apiRunning && showErrors ? " lz-visible" : "");
    return classs;
  }

  function makeErrors(errors, showErrors = true) {
    if (showErrors)
      return errors.slice(0, 1).map((error, index) => {
        if (error)
          return (
            <div className="lz-error" key={index}>
              <span>{error}</span>
            </div>
          );
      });
    else return null;
  }

  function getErrorClass(errors, showErrors = true, apiRunning = false, errorDisabled = false) {
    if (errorDisabled) return "";
    if (!apiRunning && showErrors) {
      return errors.length > 0 ? " lz-input-error" : " lz-input-success";
    } else return "";
  }

  return Field;
};
